<template>
    <div>
        <div class="">
            <div v-bind:class="{'table-responsive':true, 'text-nowrap':!fitCellSizes}">
                <table class="table table-sm table-condensed table-hover table-bordered small m-0">
                    <thead>
                        <tr>
                            <th v-if="showTotals" class="border-0"></th>
                            <th v-if="multiselect && showMultiColumn" class="text-center subtable-header-style">
                                <div v-show="lstOfDatRows && lstOfDatRows.length > 0" class="wPointer">
                                    <span class="mdi mdi-checkbox-blank-outline" v-if="!isAllRowSelected" @click="fnToggleAllSel()"></span>
                                    <span class="mdi mdi-checkbox-marked-outline" v-if="isAllRowSelected" @click="fnToggleAllSel()"></span>
                                    <sup class="">{{$n(selectedRows.length)}}</sup>
                                </div>
                            </th>
                            <th v-if="hasSubtable" class="text-center subtable-header-style"></th>
                            <th v-for="column in lstColumns" v-if="fnEvalCondition(column.Conditions) && fnIsVisible(column) && column.gtShown"
                                :class="{'sorted': column.sort != 'NOS', 'subtable-header-style': column.sort == 'NOS' }">
                                <div @click.left.prevent="fnSortBy(column)"
                                     @click.right.prevent="fnShowColModal(column)"
                                     :class="{'wPointer': column.CanSort == true}">
                                    <div class="">
                                        <span class="mdi mdi-record" v-if="column.sort == 'NOS' && column.CanSort == true"></span>
                                        <span class="mdi mdi-play mdi-rotate-90" v-if="column.sort == 'DESC' && column.CanSort == true"></span>
                                        <span class="mdi mdi-play mdi-rotate-270" v-if="column.sort == 'ASC' && column.CanSort == true"></span>
                                        <span v-if="!column.IconHeader">{{ column.Label | capitalize }}</span>
                                        <span v-if="column.IconHeader" :class="column.IconHeader"></span>
                                        <sup v-if="badgeColSortOrder(column) != -1">{{badgeColSortOrder(column)}}</sup>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-for="(entry, index) in lstOfDatRows">
                        <tr @click="fnRowClick(entry, index)"
                            @dblclick="fnDoubleRowClick(entry, index)"
                            :class="{'table-secondary': isRowSelected(entry), 'bg-info-row': applyInfoBackground }"
                            @mouseover="fnMouseOver(index)"
                            @mouseleave="fnMouseLeave(index)">
                            <td v-if="showTotals" class="border-0"></td>
                            <td v-if="multiselect && showMultiColumn" class="text-center align-middle">
                                <div class="wPointer">
                                    <span class="mdi mdi-checkbox-blank-outline" v-show="!isRowSelected(entry)"></span>
                                    <span class="mdi mdi-checkbox-marked-outline" v-show="isRowSelected(entry)"></span>
                                </div>
                            </td>
                            <td v-if="hasSubtable" class="text-center align-middle" @click="entry.collapsed = !entry.collapsed">
                                <div class="wPointer">
                                    <span :class="`mdi mdi-chevron-${entry.collapsed ? 'right' : 'down'}`" />
                                </div>
                            </td>
                            <td :title=$t(col.Tooltip) :style="fnCssCellStyle(entry, col, index)" v-for="col in lstColumns" v-if="fnEvalCondition(col.Conditions) && fnIsVisible(col) && col.gtShown" class="align-middle">
                                <div :title="fnGetDataValue(entry, col)" v-if="col.ParamId == null && col.CellType == null" class="ellipsis-line-clamp-4">
                                    {{fnGetDataValue(entry, col)}}
                                </div>
                                <div :title="formatValueCodParam(fnGetDataValue(entry, col), col.ParamId)" class="ellipsis-line-clamp-4" v-if="col.ParamId != null && (!col.conditionalValues || col.conditionalValues.filter(x => x.Value != '').length == 0)">{{formatValueCodParam(fnGetDataValue(entry, col), col.ParamId)}}</div>

                                <country-flag v-if="col.CellType == 'FlagType'" :country="fnGetDataValue(entry, col)" size="normal" rounded />

                                <cell-dt-string-type-component v-if="col.CellType == 'StringType'"
                                                               :value="fnGetDataValue(entry, col)" :index="index" :readTransform="col.ReadTransform"
                                                               :conditionsDict="col.conditionalValues" />
                                <cell-dt-date-type-component v-if="col.CellType == 'DateType'" :value="fnGetDataValue(entry, col)" :format="col.Format" />
                                <cell-dt-number-type-component v-if="col.CellType == 'NumberType'" :value="fnGetDataValue(entry, col)" :outcomes="col.Values"
                                                               :format="col.Format" :readTransform="col.ReadTransform" :conditionsDict="col.conditionalValues" :index="index"
                                                               :currency="getCurrencyParam(index)" :area="getAreaParam(index)" :frequency="getFreqParam(index)" />
                                <cell-dt-boolean-type-component v-if="col.CellType == 'BooleanType'" :value="fnGetDataValue(entry, col)" :outcomes="col.Values" />
                                <cell-dt-link-type-component v-if="col.CellType == 'LinkType'"
                                                             :value="fnGetDataValue(entry, col)"
                                                             :paramValue="col.ParamId != null ? formatValueCodParam(fnGetDataValue(entry, col), col.ParamId) : null"
                                                             :index="index"
                                                             :conditionsDict="col.conditionalValues" :readTransform="col.ReadTransform"
                                                             :format="col.Format" :currency="getCurrencyParam(index)" :area="getAreaParam(index)" :frequency="getFreqParam(index)" :precedent="getPrecedentNum(index)"
                                                             @btn-click="fnCallBack($event, col, entry)" />
                                <cell-dt-toggle-type-component v-if="col.CellType == 'ToggleType'"
                                                               :value="fnGetDataValue(entry, col)" :index="index" :toggleKey="keyDate" color="var(--jll-red)" :readTransform="col.ReadTransform"
                                                               @btn-click="fnCallBack($event, col, entry)" />
                            </td>
                        </tr>
                        <tr v-if="hasSubtable && !entry.collapsed">
                            <td :colspan="2*lstColumns.length" class="subtableFontSize subtableBackground">
                                <keep-alive>
                                    <component :is="subtableComponent.component" :id="entry[keyField]"></component>
                                </keep-alive>
                            </td>
                        </tr>
                        <!-- Totals -->
                        <!--<tr v-if="showTotals" class="totals-font-style">
                            <td class="border-0">{{ $t('common.lblTotal') }}</td>
                            <td v-if="multiselect && showMultiColumn" class="border-0"></td>
                            <td v-for="col in lstColumns" v-if="fnEvalCondition(col.Conditions) && fnIsVisible(col) && col.gtShown" class="text-end border-0">
                                <div v-if="col.IsTotalRow">
                                    {{fnGetTotalValue(col)}}
                                </div>
                            </td>
                        </tr>-->
                    </tbody>
                </table>
            </div>
            <div v-if="loading">
                    <v-progress-linear
                            indeterminate
                            color="rgb(100, 100, 100)"
                    />
            </div>
            <div v-if="!lstOfDatRows || lstOfDatRows.length == 0">
                <div v-if="!loading" class="alert alert-warning text-center" role="alert">
                    No Data
                </div>
                <div v-if="loading" class="alert alert-secondary text-center">
                    Loading
                </div>
            </div>
        </div>
        <!-- Modal de columnas -->
        <div>
            <div class="modal fade" :id="idcolumnListModal" data-backdrop="static" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{$t('components.genericTable.columnList.modalTitle')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body p-0">
                            <div class="table-responsive text-nowrap">
                                <table class="table table-sm table-condensed table-hover table-bordered small m-0">
                                    <thead>
                                        <tr>
                                            <th>
                                                {{$t('components.genericTable.columnList.index')}}
                                            </th>
                                            <th width="100%">
                                                {{$t('components.genericTable.columnList.column')}}
                                            </th>
                                            <th class="text-center">
                                                {{$t('components.genericTable.columnList.isVisible')}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <draggable v-model="lstColumns" tag="tbody" handle=".handle">

                                        <tr v-for="(column, index) in lstColumns" v-if="fnEvalCondition(column.Conditions) && fnIsVisible(column)" :key="column.gtOrder">
                                            <td :class="{'text-muted': column.gtShown == false}">
                                                <div class="">
                                                    <span class="mdi mdi-menu grabbable handle"></span>
                                                    {{index}}
                                                </div>
                                            </td>
                                            <td :class="{'text-muted': column.gtShown == false}" width="100%">
                                                {{ $t(column.Label) | capitalize }}
                                            </td>
                                            <td :class="{'text-center wPointer': column.gtShown == true, 'text-center table-secondary wPointer': column.gtShown == false}">
                                                <div @click="column.gtShown = !column.gtShown">
                                                    <span class="mdi mdi-checkbox-blank-outline" v-if="!column.gtShown"></span>
                                                    <span class="mdi mdi-checkbox-marked-outline" v-if="column.gtShown"></span>
                                                </div>
                                            </td>
                                        </tr>

                                    </draggable>
                                </table>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-warning" @click.prevent="fnResetTableConf()">{{$t('common.lblReset')}}</button>
                            <button type="button" class="btn btn-outline-primary" v-if="uniqueTableName" @click.prevent="fnSaveTableConf()">{{$t('common.lblSave')}}</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal">{{$t('common.lblClose')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import _, { forEach } from "lodash";
    import $ from 'jquery';
    import draggable from 'vuedraggable'
    import LazUtils from '@/shared/utils/LazUtils.js';
    import CellDtDateTypeComponent from "@/shared/components/common/CellTypes/DynamicTable/CellDtDateType.vue";
    import CellDtNumberTypeComponent from "@/shared/components/common/CellTypes/DynamicTable/CellDtNumberType.vue";
    import CellDtBooleanTypeComponent from "@/shared/components/common/CellTypes/DynamicTable/CellDtBooleanType.vue";
    import CellDtLinkTypeComponent from "@/shared/components/common/CellTypes/DynamicTable/CellDtLinkType.vue";
    import CellDtStringTypeComponent from "@/shared/components/common/CellTypes/DynamicTable/CellDtStringType.vue";
    import CellDtToggleTypeComponent from "@/shared/components/common/CellTypes/DynamicTable/CellDtToggleType.vue";
    import GenericFormService from '@/shared/services/genericConfig/GenericFormService.js';
    import GenericTableService from '@/shared/services/genericConfig/GenericTableService.js';
    import CountryFlag from 'vue-country-flag';
    import fn from "@/shared/utils/commonFunctions.js";

    export default {
        props: {
            dataRows: Array,
            columns: { type: Array, default: function () { return []; } },
            multiselect: { type: Boolean, default: false },
            uniqueTableName: { type: String, default: null },
            showModalColumnConfig: { type: Boolean, default: true },
            allowColumnConfig: { type: Boolean, default: true },
            showMultiColumn: { type: Boolean, default: true },
            refresh: false,
            outsideRowSelected: null,
            colsAndSort: { type: Array, default: function () { return []; } },
            nSelectedRows: { type: Array, default: function () { return []; } },
            keyField: { type: String, default: null }, // contains the field name that will be used as
            customClassCell: Array, // this is a prop that contains specified styles to apply to specified cells. Sample: [{ fld: "unitValDes", classToApply: "md-field-width" }, { fld: "provDesc", classToApply: "sm-field-width" }]
            applyInfoBackground: { type: Boolean, default: false }, // indicate if apply 'bg-info-row' class to all rows of the table (see applyInfoBackground())
            hasSubtable: { type: Boolean, default: false }, // indicates if subtable exists
            fitCellSizes: { type: Boolean, default: false }, // fits or not cell sizes
            loading: { type: Boolean, default: false },
            subtableComponent: Object // component to be rendered if subtable
        },
        data: function () {
            return {
                lstColumns: [],
                tableWithParamLists: false,
                lstColsAndSort: [],
                selectedRows: [],
                rowIndex: null,

                showColConfigDiv: false,
                idcolumnListModal: LazUtils.newId(),
                keyDate: null,
                showTotals: false
            }
        },
        components: {
            draggable,
            CellDtDateTypeComponent,
            CellDtNumberTypeComponent,
            CellDtBooleanTypeComponent,
            CellDtLinkTypeComponent,
            CellDtStringTypeComponent,
            CellDtToggleTypeComponent,
            CountryFlag
        },
        computed: {
            lstOfDatRows: function () {
                this.keyDate = Date.now();
                if (this.hasSubtable) { // If subtable, make all groups collapsed
                    this.dataRows.forEach(s => s.collapsed = true);
                }
                return this.dataRows;
            },
            isAllRowSelected: function () {

                if (!this.dataRows)
                    return false;

                /* Se verifica si están todas seleccionadas */
                if (this.dataRows.length == this.selectedRows.length && this.selectedRows.length > 0)
                    return true;
                else
                    return false;
            }
        },
        watch: {

            /**
             * Wacther para cuando se marca el flag de que hay columnas de tipo param list para verificar que se tenga
             * o que se carguen los datos del param list,
             */
            tableWithParamLists: function (newValue, oldValue) {
                var thisData = this;
                _.forEach(thisData.columns, function (col) {
                    if (_.has(col, 'ParamId') && col.ParamId != null) {
                        /* Columna con ParamList Hay que verificar si se tiene en memoria y si no se pide al servidor */
                        if (!thisData.$store.getters.IsCodParamInState(col.ParamId)) {

                            /* Se pide al servidor y cuando lleguen ya se pintarán */
                            thisData.$store.dispatch('GetCodParamFromServer', col.ParamId)
                        }
                    }
                });
            },
            /**
             * Watcher para reaccionar al cambio en la propiedad que contiene las columnas con lo
             * que se rellena el dato de lista de columnas internas para poder operar con ellas.
             * @param newValue
             * @param oldValue
             */
            columns: function (newValue, oldValue) {

                var thisData = this;
                thisData.lstColumns = [];
                _.forEach(newValue, function (col) {

                    var newCol = _.clone(col);
                    if (!_.has(newCol, 'VisibleByDefault')) {
                        newCol.VisibleByDefault = false;
                    }
                    if (newCol.VisibleByDefault == true) {
                        newCol.gtShown = newCol.gtShown != null ? newCol.gtShown : true;
                    } else {
                        newCol.gtShown = false;
                    }
                    thisData.lstColumns.push(newCol);
                });
                this.fnMountNewConfig()
            },
            nSelectedRows: function (selectedRows) {
                this.selectedRows = selectedRows;
            },
            colsAndSort: function (colsAndSortList) {
                this.lstColsAndSort = colsAndSortList;
                this.lstColumns.forEach(column => { column.sort = 'NOS' });
                this.lstColsAndSort.forEach(x => {
                    let column = this.lstColumns.find(y => y.fld == x.fld);
                    if (column != null) column.sort = x.sort;
                });
            },
            /**
             * Watcher para verificar que se ha seleccionado una fila desde fuera de la tabla - para interacción markers y tabla
             * @param row
             */
            outsideRowSelected: function (row) {
                if (row == null) {
                    // Se limpia la selección de filas
                    this.selectedRows = [];
                }
                else
                    this.fnRowClick(row);
            },
            /**
             * Watcher para refrescar la selección en la tabla
             * @param newValue
             */
            refresh: function (newValue) {
                if (newValue) {
                    // Se limpia la selección de filas
                    this.selectedRows = [];
                }
            }
        },
        filters: {
            /**
             * Capitaliza los textos de las columnas
             * @param str
             */
            capitalize: function (str) {
                //return _.capitalize(str);
                return _.upperFirst(str);
            }
        },
        methods: {
            /**
             * Cambia toda selección.
             * */
            fnToggleAllSel: function () {
                if (this.isAllRowSelected) {
                    this.selectedRows = [];
                } else {
                    this.selectedRows = [];
                    for (var lCnt = 0; lCnt < this.lstOfDatRows.length; lCnt++) {

                        this.selectedRows.push(this.lstOfDatRows[lCnt]);
                    }
                }
                this.fnEmitAllRowSelected();
            },
            /**
             * Gestión del click en una fila
             * @param row
             */
            fnRowClick: function (row, index, isDouble) {
                this.rowIndex = index;
                if (this.multiselect) {
                    /* SI no hay seleccionados se añade y punto */
                    if (this.selectedRows.length == 0) {
                        this.selectedRows.push(row);
                    }

                    /* Se itera entre los seleccionados si se encuentra se elimina */
                    else {
                        var found = false;
                        for (var lCnt = 0; lCnt < this.selectedRows.length; lCnt++) {
                            if (_.isEqual(this.selectedRows[lCnt], row)) {
                                found = true;
                                this.selectedRows.splice(lCnt, 1);
                            }
                            else if (this.keyField != null
                                && this.keyField != 'undefined'
                                && _.has(this.selectedRows[lCnt], this.keyField)
                                && _.has(row, this.keyField)
                                && this.selectedRows[lCnt][this.keyField] == row[this.keyField]) {
                                found = true;
                                this.selectedRows.splice(lCnt, 1);
                            }
                        }
                        if (!found) this.selectedRows.push(row);
                    }

                }
                else {
                    /* SI no hay seleccionados se añade y punto */
                    if (this.selectedRows.length == 0) {
                        this.selectedRows.push(row);
                    }
                    /* Si se clica otra fila */
                    else if (this.selectedRows.length == 1) {

                        /* Si es la misma se elimina del array */
                        if (_.isEqual(this.selectedRows[0], row)) {
                            this.selectedRows.splice(0, 1);
                        }
                        else if (this.keyField != null
                            && this.keyField != 'undefined'
                            && _.has(this.selectedRows[lCnt], this.keyField)
                            && _.has(row, this.keyField)
                            && this.selectedRows[lCnt][this.keyField] == row[this.keyField]) {
                            this.selectedRows.splice(0, 1);
                        }
                        else {
                            this.selectedRows.splice(0, 1);
                            this.selectedRows.push(row);
                        }
                    }
                }

                this.fnEmitRowSelected(isDouble);
            },

            /**
             * Gestión del doble click en una fila
             * @param row
             */
            fnDoubleRowClick(row, index) {
                // Misma funcionalidad que un único click - indicar que es double para lanzar evento distinto
                this.fnRowClick(row, index, true)
            },

            fnEmitRowSelected(isDouble) {
                /* Indicar evento que se genera -> cambio de selección (click simple) o doble click */
                let clickEvt = null;
                if (!isDouble) {
                    clickEvt = 'evt-generic-table-change-selection';
                } else {
                    clickEvt = 'evt-generic-table-double-click';
                }

                if (this.selectedRows.length > 0) {
                    /* Se clona la lista seleccionada */
                    var cpyRows = _.cloneDeep(this.selectedRows);

                    if (!this.multiselect)
                        this.$emit(clickEvt, cpyRows[0]);
                    else
                        this.$emit(clickEvt, { rows: cpyRows, index: this.rowIndex });
                }
                else {
                    if (!this.multiselect)
                        this.$emit(clickEvt, null);
                    else
                        this.$emit(clickEvt, { rows: null, index: this.rowIndex });
                }
            },
            fnEmitAllRowSelected() {
                if (this.selectedRows.length > 0) {
                    var cpyRows = _.cloneDeep(this.selectedRows);
                    this.$emit('evt-generic-table-all-selection', { rows: cpyRows });
                } else {
                    this.$emit('evt-generic-table-all-selection', { rows: null });
                }
            },
            /**
             * Indica si una fila está seleccionada
             * @param row
             */
            isRowSelected: function (row) {
                /* SI no hay seleccionados se añade y punto */
                if (this.selectedRows.length == 0) {
                    return false;
                }

                /* Se itera entre los seleccionados si se encuentra se elimina */
                for (var lCnt = 0; lCnt < this.selectedRows.length; lCnt++) {
                    if (_.isEqual(this.selectedRows[lCnt], row)) {
                        return true;
                    }
                    else if (this.keyField != null
                        && this.keyField != 'undefined'
                        && _.has(this.selectedRows[lCnt], this.keyField)
                        && _.has(row, this.keyField)
                        && this.selectedRows[lCnt][this.keyField] == row[this.keyField]) {
                        this.selectedRows[lCnt] = row; // overwrite selectedRow with updated value
                        return true;
                    }

                }

                return false;  /* Hasta aquí hemos llegado pero no se ha encontrado en la colección por lo que no está seleccionada */
            },


            /**
             * Gestión de la ordenación por click en una de las columnas.
             * @param col
             */
            fnSortBy: function (col) {

                if (!col.CanSort)
                    return;

                /* Se fija el sentido de ordenación */
                var pCol = this.lstColumns.find(x => x.InternalField == col.InternalField);
                let currentSort = pCol.sort
                this.lstColumns.forEach(function (it) {
                    it.sort = "NOS"
                })

                if (currentSort == "NOS") {
                    pCol.sort = "ASC";
                } else if (currentSort == "ASC") {
                    pCol.sort = "DESC";
                } else {
                    pCol.sort = "NOS";
                }

                /* Se recompone el array de columnas y su orden para dejarlo sincronizado para el evento */
                if (pCol.sort == "NOS") {
                    this.lstColsAndSort.splice(0, this.lstColsAndSort.length)
                } else if (pCol.sort == "ASC") {

                    ///* Se busca en la colección */
                    //var idx = this.lstColsAndSort.findIndex(x => x.fld == pCol.InternalField);

                    ///* Si existe se cambia el orden a ASC */
                    //if (idx > -1)
                    //    this.lstColsAndSort[idx].sort = "ASC";
                    //else {
                    this.lstColsAndSort.splice(0, this.lstColsAndSort.length)
                    /* No se ha encontrado se añade al final */
                    this.lstColsAndSort.push({ fld: pCol.InternalField, sort: "ASC" });

                } else {
                    /* Se busca en la colección */
                    this.lstColsAndSort.splice(0, this.lstColsAndSort.length)
                    /* No se ha encontrado se añade al final */
                    this.lstColsAndSort.push({ fld: pCol.InternalField, sort: "DESC" });

                }
                /* Se emite un evento de que hay que reordenar */
                this.$emit('evt-generic-table-change-sort-order', this.lstColsAndSort);
            },
            /**
             * Devuelve el orden en la ordenación de columnas de la pCol
             * @param pCol
             */
            badgeColSortOrder: function (pCol) {

                /* Hay que quitarla de la colección */
                var idx = this.lstColsAndSort.findIndex(x => x.fld == pCol.fld);
                if (idx > -1)
                    return idx + 1;
                else
                    return idx;
            },
            fnGetUrl: function (col, entry) {
                let url = '';
                if (_.has(col, 'url') && _.isFunction(col['url'])) {

                    /* Se llama al callback de verificación que conoce el padre */
                    url = col['url'](col.fld, entry);
                } else {

                    /* No hay función de verificación se tira con true */
                    url = '';
                }

                return url;

            },
            /**
             * Función para llamar a un callback cuando se hace click en un botón de una columna.
             * @param col
             * @param entry
             */
            fnCallBack: function (newTab, col, entry, value) {
                /* Se verifica que la columna tenga propiedad de actuación */
                if (_.has(col, 'EmitEventName') && col['EmitEventName']) {
                    /* Se llama al callback de actuación que conoce el padre */
                    this.$parent.$parent[col['EmitEventName']](col.fld, entry, value, newTab);
                }
            },
            /**
             * Función que determina si una columna es visible o no. (definida en la columna del padre)
             * @param col
             */
            fnEvalCondition: function (sConditions, value, index) {
                if (sConditions) {
                    let metCondition = false;
                    if (_.isFunction(this.$parent.$parent[sConditions])) {
                        // If conditions is a function
                        if (!fn.isEmpty(index)) {
                            metCondition = this.$parent.$parent[sConditions](this.lstOfDatRows[index]);
                        }
                        else {
                            metCondition = this.$parent.$parent[sConditions]();
                        }
                    } else {

                        // When evaluating field condition
                        if (!fn.isEmpty(index)) {
                            let element = this.lstOfDatRows[index];
                            let internalFields = GenericFormService.getInternalFieldMatches(sConditions);
                            for (var internalField of internalFields) {
                                let modelValue = element[internalField];
                                if (_.isFunction(this.$parent[internalField])) {
                                    sConditions = sConditions.replace(internalField, this.$parent[internalField](value));
                                } else {
                                    if (typeof modelValue === 'string') modelValue = "'" + modelValue + "'";
                                    sConditions = sConditions.replace(internalField, modelValue);
                                }
                            }
                            metCondition = eval(sConditions);
                        }
                        // When evaluating column condition
                        else {
                            // If conditions is combined fields
                            let internalFields = GenericFormService.getInternalFieldMatches(sConditions);
                            let index = 0;
                            while (!metCondition && index < this.lstOfDatRows.length) {
                                let element = this.lstOfDatRows[index];
                                for (var internalField of internalFields) {
                                    if (_.isFunction(this.$parent[internalField])) {
                                        sConditions = sConditions.replace(internalField, this.$parent[internalField](value));
                                    } else {
                                        let value = element[internalField];

                                        if (typeof value === 'string') value = "'" + value + "'";

                                        sConditions = sConditions.replace(internalField, value);
                                    }
                                }
                                metCondition = eval(sConditions);
                                index++;
                            }
                        }
                    }

                    return metCondition;
                }
                else return true;
            },
            /**
             * Función que determina si una columna es visible o no en función de los roles
             * @param col
             */
            fnIsVisible: function (col) {
                let bAuth = true, bNonAuth = true;
                if (col.AuthorizedRoles) {
                    bAuth = this.$store.getters.isInRoleArr(col.AuthorizedRoles);
                }
                if (col.NonAuthorizedRoles) {
                    bNonAuth = !this.$store.getters.isInRoleArr(col.NonAuthorizedRoles);
                }
                return bAuth && bNonAuth;
            },
            /**
             * Función para lanzar la callbanck indicada en la propiedad
             * fnFormat de la columna para que el padre formatee según considere.
             * @param col
             * @param entry
             */
            fnCustomFormatCallBack: function (col, entry) {
                /* Se verifica que la columna tenga propiedad de actuación */
                if (_.has(col, 'fnFormatCell') && _.isFunction(col['fnFormatCell'])) {

                    /* Se llama al callback de formateo que conoce el padre */
                    return col['fnFormatCell'](col.fld, entry);
                } else
                    return entry[col.fld];
            },
            /**
            * Función formatear el value por codPram.
            * */
            formatValueCodParam: function (value, paramId) {
                /* Se verifica si este no está en memoria para recargarlo (cambio de idioma por ejemplo) */
                if (!this.$store.getters.IsParamIdInState(paramId)) {

                    /* Se pide al servidor y cuando lleguen ya se pintarán */
                    this.$store.dispatch('GetParamIdFromServer', paramId);
                }
                try {
                    var list = this.$store.getters.paramIdListFor(paramId);
                    let val = list != null ? list.find(x => x.valueCode == value) : null;
                    return val != null ? val.valueDesc : value;
                } catch (e) {
                    return "Error FieldDataType Format"
                }
                return value;
            },
            fnGenerateFormat: function (col, entry) {
                if (!_.has(col, 'Format'))
                    return null;

                if (!_.isFunction(col['Format'])) // Has sufix and it isn't a function. Return the field value.
                    return entry[col.Format];
            },
            fnEnabledField: function (col, entry) {
                if (!_.has(col, 'enabled'))
                    return true;

                if (!_.isFunction(col['enabled'])) // Has enabled and it isn't a function. Return the field value.
                    return col.enabled;

                if (!_.has(col, 'enabledParams')) // It's a function without parameter.
                    return col['enabled']();

                // It's a function and has one or more parameters. If there are more than one parameter, this must be treated by the concrete table.
                return col['enabled'](entry, col.enabledParams);
            },
            /**
             * Función para mostrar o no la modal de columnas
             * @param col
             */
            fnShowColModal: function (col) {
                if (this.showModalColumnConfig == true && this.allowColumnConfig === true)
                    $('#' + this.idcolumnListModal).modal('show');
                else if (this.allowColumnConfig === true)
                    this.showColConfigDiv = true;
                else {
                    //Ntd
                }
            },
            /**
             * Guarda la configuración de la tabla en localstorage
             * */
            fnSaveTableConf: function () {
                try {
                    const tableName = this.uniqueTableName ? this.uniqueTableName : "LazGenTableConfig";
                    const configStr = localStorage.getItem(tableName);

                    /* Si existe se guarda la configuración */
                    if (configStr) {
                        const cfgObj = JSON.parse(configStr);
                        var pCfgTbl = cfgObj.find(x => x.tblName == this.uniqueTableName);

                        /* Si no hay en la colección de configuraciones una tabla de este nombre */
                        if (pCfgTbl == null) {
                            var cfgItem = { tblName: this.uniqueTableName, colCfg: [] };
                            var lOrder = 0;
                            _.forEach(this.lstColumns, function (col) {
                                var colCfgItem = { fld: col.InternalField, lbl: col.Label, gtShown: col.gtShown, gtOrder: lOrder++ };
                                cfgItem.colCfg.push(colCfgItem);
                            });
                            cfgObj.push(cfgItem);
                            localStorage.setItem(tableName, JSON.stringify(cfgObj));
                        } else {

                            /* Si ya hay en la colección de configuraciones */
                            pCfgTbl.colCfg = [];
                            var lOrder = 0;
                            _.forEach(this.lstColumns, function (col) {
                                var colCfgItem = { fld: col.InternalField, lbl: col.Label, gtShown: col.gtShown, gtOrder: lOrder++ };
                                pCfgTbl.colCfg.push(colCfgItem);
                            });
                            localStorage.setItem(tableName, JSON.stringify(cfgObj));
                        }
                    } else {
                        var cfgItem = { tblName: this.uniqueTableName, colCfg: [] };
                        var lOrder = 0;
                        _.forEach(this.lstColumns, function (col) {
                            var colCfgItem = { fld: col.InternalField, lbl: col.Label, gtShown: col.gtShown, gtOrder: lOrder++ };
                            cfgItem.colCfg.push(colCfgItem);
                        });
                        var arrConf = [];
                        arrConf.push(cfgItem);
                        localStorage.setItem(tableName, JSON.stringify(arrConf));
                    }
                    this.$toasted.show(this.$t('components.genericTable.columnList.msgConfigSaved'), { type: 'success' });
                } catch (err) {
                    this.$toasted.show(this.$t('components.genericTable.columnList.msgConfigSavedErr'), { type: 'error' });
                }
            },
            /**
             * Resetea la configuración de mostrar columnas de la tabla.
             * */
            fnResetTableConf: function () {
                var thisData = this;
                let columnsSorted = _.sortBy(thisData.lstColumns, ['Order']);
                var lOrder = 0;
                _.forEach(columnsSorted, function (col) {

                    var confCol = columnsSorted.find(x => x.InternalField == col.InternalField && x.Label == col.Label); // It's possible that several columns has empty fld, so let's use fld && lbl
                    if (confCol != null) {
                        confCol.gtOrder = lOrder++;
                        if (!_.has(col, 'VisibleByDefault'))
                            confCol.gtShown = false;
                        else
                            confCol.gtShown = col.VisibleByDefault;
                    }
                });
                thisData.lstColumns = _.sortBy(thisData.lstColumns, ['gtOrder']);

            },
            /**
             * Lanza evento indicando mouse over
             * @param entry
             * */
            fnMouseOver(index) {
                this.$emit('evt-generic-table-mouseover', index);
            },
            /**
             * Lanza evento indicando mouse leave
             * @param entry
             */
            fnMouseLeave(index) {
                this.$emit('evt-generic-table-mouseleave', index);
            },

            fnMountNewConfig() {
                var thisData = this;

                let columnsSorted = _.sortBy(thisData.columns, ['Order']);

                /* Se revisa si hay propiedades con paramList y se cambia el flag para que se lancen las consultas */
                _.forEach(columnsSorted, function (col) {
                    if (_.has(col, 'ParamId')) {

                        /* Se cambia el flag para que se lancen las peticiones al servidor de los param list si no están ya en memoria */
                        thisData.tableWithParamLists = true;
                    }
                });

                // Search if some totals flag to show last row
                if (_.some(columnsSorted, 'IsTotalRow')) {
                    this.showTotals = true;
                }

                thisData.lstColumns = [];
                try {
                    if (this.uniqueTableName) {
                        /* Se carga la configuración */
                        const configStr = localStorage.getItem(this.uniqueTableName);
                        if (configStr != null) {
                            const cfgObj = JSON.parse(configStr);
                            var pCfgTbl = cfgObj.find(x => x.tblName == this.uniqueTableName);
                            if (pCfgTbl != null) {

                                /* Se inicializan las columnas y su gestión de visibilidad pero con la configuración*/
                                var lOrder = 10000;
                                _.forEach(columnsSorted, function (col) {

                                    var newCol = _.clone(col);
                                    if (!_.has(newCol, 'VisibleByDefault')) {
                                        newCol.VisibleByDefault = false;
                                    }

                                    /* Se busca el campo en configuración */
                                    var colCfg = pCfgTbl.colCfg.find(x => x.fld == col.InternalField && x.lbl == col.Label);

                                    /* Se asigna visibilidad en función de la configuración */
                                    if (_.has(colCfg, 'gtShown'))
                                        newCol.gtShown = colCfg.gtShown;
                                    else {
                                        newCol.gtShown = newCol.VisibleByDefault;
                                    }

                                    /* Si la configuración indica el orden se pone en otro caso se indica al final por orden */
                                    if (_.has(colCfg, 'gtOrder'))
                                        newCol.gtOrder = colCfg.gtOrder;
                                    else
                                        newCol.gtOrder = lOrder++;
                                    thisData.lstColumns.push(newCol);
                                });
                                thisData.lstColumns = _.sortBy(thisData.lstColumns, ['gtOrder']);
                            } else {
                                var lOrder = 0;
                                _.forEach(columnsSorted, function (col) {

                                    var newCol = _.clone(col);
                                    if (!_.has(newCol, 'VisibleByDefault'))
                                        newCol.VisibleByDefault = false;

                                    if (newCol.VisibleByDefault == true && !_.has(newCol, 'gtShown'))
                                        newCol.gtShown = true;
                                    else if (newCol.VisibleByDefault != true)
                                        newCol.gtShown = false;

                                    newCol.gtOrder = lOrder++;
                                    thisData.lstColumns.push(newCol);
                                });
                            }
                        }
                        else {
                            /* Se inicializan las columnas y su gestión de visibilidad No hay configuración prévia*/
                            var lOrder = 0;
                            _.forEach(columnsSorted, function (col) {

                                var newCol = _.clone(col);
                                if (!_.has(newCol, 'VisibleByDefault'))
                                    newCol.visible = false;

                                if (newCol.VisibleByDefault == true && !_.has(newCol, 'gtShown'))
                                    newCol.gtShown = true;
                                else if (newCol.VisibleByDefault != true)
                                    newCol.gtShown = false;

                                newCol.gtOrder = lOrder++;
                                thisData.lstColumns.push(newCol);
                            });
                        }
                    } else {

                        /* Se inicializan las columnas y su gestión de visibilidad no se marca para guardar configuración */
                        var lOrder = 0;
                        _.forEach(columnsSorted, function (col) {

                            var newCol = _.clone(col);
                            if (!_.has(newCol, 'VisibleByDefault'))
                                newCol.VisibleByDefault = false;

                            if (newCol.VisibleByDefault == true)
                                newCol.gtShown = true;
                            else
                                newCol.gtShown = false;

                            newCol.gtOrder = lOrder++;
                            thisData.lstColumns.push(newCol);
                        });
                    }

                } catch (err) {
                    console.error("TblGen - " + err.message)
                }
            },
            /**
             * Funciones para obtener params de formateo
             * @param index
             */
            getCurrencyParam(index) {
                return this.lstOfDatRows[index].currencyParamShortName || '';
            },
            getAreaParam(index) {
                return this.lstOfDatRows[index].areaParamShortName || '';
            },
            getFreqParam(index) {
                return this.lstOfDatRows[index].rentFrecuencyParamShortName || '';
            },
            getPrecedentNum(index) {
                return this.lstOfDatRows[index].precentNumber || '';
            },
            /**
             * Obtener el valor del campo al que se quiere acceder
             * @param entry
             * @param col
             */
            fnGetDataValue(entry, col) {


                let value = entry[col.InternalField];
                if (col.InitEventName) {
                    try {
                        // Execute function to get value
                        value = this.$parent[col.InitEventName](entry);
                    } catch (err) {
                        // NtD
                    }
                }
                else if (col.ComputedOperation) {

                    try {
                        let computedOperation = col.ComputedOperation;

                        // Check if it is function on parent's parent [generally inserted on modal]
                        if (_.isFunction(this.$parent.$parent[computedOperation])) {

                            value = this.$parent.$parent[computedOperation](entry);
                        } else {
                            // Else
                            let internalFields = GenericFormService.getInternalFieldMatches(computedOperation);
                            internalFields.forEach(internalField => {
                                if (entry[internalField]) {
                                    computedOperation = computedOperation.replace(internalField, entry[internalField]);
                                }
                                else {
                                    let field = entry.attributesList.find(x => x.featureName == internalField)
                                    if (field != null) {
                                        let valueField = GenericTableService.getTableValue(field);
                                        computedOperation = computedOperation.replace(internalField, valueField);
                                    }
                                }
                            });
                            value = eval(computedOperation);
                        }
                    } catch (err) {
                        // NtD
                    }
                }
                else if (fn.isEmpty(value)) {
                    try {
                        // Look into model
                        value = this.$parent.fnSearchIntoProperties(entry, col);
                    } catch (err) {
                        // NtD
                    }
                }
                return value;
            },
            /**
             * Obtener el total de un campo - SUMA
             **/
            fnGetTotalValue(col) {
                let value = _.sumBy(this.lstOfDatRows, col.InternalField);
                if (value === undefined) {
                    try {
                        // Look into model
                        value = this.$parent.fnCalculateFromProperties(col);
                    } catch (err) {
                        // NtD
                    }
                }
                return value;
            },
            /**
            * Obtener estilo condicional
            **/
            fnCssCellStyle(entry, col, rowidx) {
                var styleDict = {}
                if (col.Size != null) {
                    styleDict["width"] = col.Size + '%'
                }
                if (col.conditionalValues != null) {
                    var found = false;
                    var index = 0;
                    // Eval expression

                    while (index < col.conditionalValues.length) {
                        if (col.conditionalValues[index].CssCellStyle != null) {
                            found = this.fnEvalCondition(col.conditionalValues[index].ValueCondition, entry[col.InternalField], rowidx);
                        }
                        
                        if (found) {
                            var customStyles = col.conditionalValues[index].CssCellStyle.split(";");
                            customStyles.forEach(function (x) {
                                var style = x.split(":")
                                styleDict[style[0].trim()] = style[1].trim()
                            })
                            found = !found
                        }

                        index++;
                    }
                }


                return styleDict;
            }
        },
        mounted() {
            this.fnMountNewConfig()
        }
    }
</script>
<style scoped>
    .wPointer {
        cursor: pointer;
    }

    .grabbable {
        cursor: move; /* fallback if grab cursor is unsupported */
        cursor: grab;
        cursor: -moz-grab;
        cursor: -webkit-grab;
    }

        /* (Optional) Apply a "closed-hand" cursor during drag operation. */
        .grabbable:active {
            cursor: grabbing;
            cursor: -moz-grabbing;
            cursor: -webkit-grabbing;
        }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s ease-in-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .sm-field-width {
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .md-field-width {
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .bold {
        font-weight: bold;
    }

    .bg-info-row {
        background-color: #eaf5fb;
    }

    .text-end {
        text-align: end;
    }

    .totals-font-style {
        font-weight: bold;
        font-size: 14px;
    }

    .subtableFontSize {
        font-size: 15px;
    }

    .subtableBackground {
        background: white;
    }

    .ellipsis-line-clamp-4 {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
    }

    td {
        min-width: 30px;
    }
</style>